var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-main',[_c('div',{staticClass:"col-md-12 ml-sm-auto col-lg-12 px-4"},[_c('v-breadcrumbs',{attrs:{"items":_vm.breadcrumbs}}),_vm._v(" "),_c('div',{staticClass:"container mt-5",attrs:{"id":"app"}},[_c('div',{staticClass:"mb-5"})])],1)])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1bdf77ea","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Dashbord/Performance.vue
// module id = null
// module chunks = 